import { render, staticRenderFns } from "./Errors.vue?vue&type=template&id=1ef736c9&scoped=true&"
import script from "./Errors.vue?vue&type=script&lang=ts&"
export * from "./Errors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef736c9",
  null
  
)

export default component.exports